import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { EgPage, EgShell } from '@expertgroup/shell';
import { AppSidebar } from './app.sidebar';
import { AppHeader } from './app.header';

/**
 * Ljuska, na @expertgroup/shell.
 *
 * Ovde je nekad stajao `containerClass()` sa trinaest klasa: sedam menu modova
 * (overlay/static/slim/horizontal/compact/reveal/drawer) i sest bool stanja.
 * Iza njih je bilo 1.657 linija Avalon SCSS-a i `LayoutService` sa deset
 * zastavica. Sina je jedna, fiksna i 256px siroka; nista od toga nije trebalo.
 *
 * `data.fullWidth` na ruti sada znaci `flush`: ekran sam vodi svoje panove, bez
 * ljuskinog scroller-a i bez kape. Trazi ga samo /ekosistem, koji ima svoju
 * viewport aritmetiku (jedan scroller po ekranu). Od UX pregleda 1 ekran nema
 * sopstvenu tamnu povrsinu: tokeni ljuske, prati `data-theme` kao i ostali.
 */
@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [AppHeader, AppSidebar, RouterModule, EgShell, EgPage],
    template: `<eg-shell>
        <div app-sidebar rail></div>
        <header app-header></header>
        <eg-page [flush]="fullWidth()">
            <router-outlet></router-outlet>
        </eg-page>
    </eg-shell>`
})
export class AppLayout {
    private readonly router = inject(Router);
    private readonly activatedRoute = inject(ActivatedRoute);

    /**
     * Ekrani koji traze celo platno (`data: { fullWidth: true }`). Cita se sa
     * NAJDUBLJE aktivirane rute, isto kao app.breadcrumb.
     */
    readonly fullWidth = toSignal(
        this.router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            map(() => this.deepestRouteData()['fullWidth'] === true)
        ),
        { initialValue: false }
    );

    private deepestRouteData(): Record<string, unknown> {
        let route = this.activatedRoute.root;
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route.snapshot.data;
    }
}
